<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="sign-wrap" :style="{ height: height }">
      <div class="sign-login-wrap">
        <img class="login-logo" src="../../assets/login.png" alt="" />
        <h2>{{ $t("login.login") }}</h2>
        <el-input
          v-model="username"
          :placeholder="usernamePlaceholder"
          @input="emailChange"
        ></el-input>
        <el-input
          v-model="password"
          type="password"
          :placeholder="passwordPlaceholder"
          @input="passwordChange"
        ></el-input>
        <div v-if="isLogin" class="login-btn act" @click="loginBtn">
          {{ $t("login.login") }}
        </div>
        <div v-else class="login-btn">{{ $t("login.login") }}</div>
        <div class="login-sub">
          <div class="login-forget"  @click="toPathContent(1)">{{ $t("login.forget") }}</div>
          <el-checkbox v-model="checked">{{ $t("login.read") }}</el-checkbox>
          <span @click="policy(1)" class="login-policy">{{
            $t("login.userPolicy")
          }}</span>
          <span @click="policy(2)" class="login-policy">{{
            $t("login.policy")
          }}</span>
        </div>
        <div class="login-botton">
          <span @click="toPath('smsLogin')">{{
            $t("login.messageLogin")
          }}</span>
          <span @click="toPathContent(0)" class="login-register-btn">{{
            $t("login.newRegister")
          }}</span>
        </div>
      </div>
    </div>
    <div class="privacyWrap" v-if="isSHowPrivacy">
      <div class="privacy">
        <div class="privacyClose">
          <i class="el-icon-close" @click="closePrivacy"></i>
        </div>
        <div class="privacyContent">
          <privacyH5 :http="https"></privacyH5>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import privacyH5 from "./components/privacyH5.vue";
import { getLogin } from "@/api/api";
import { resolve } from 'url';
export default {
  components: { top, bottom, privacyH5 },
  name: "home",
  data() {
    return {
      height: "",
      username: "",
      password: "",
      isLogin: false,
      checked: true,
      langSet: "",
      usernamePlaceholder: "",
      passwordPlaceholder: "",
      https: "",
      isSHowPrivacy: false,
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "zh";
    this.usernamePlaceholder = this.$t("login.username");
    this.passwordPlaceholder = this.$t("login.password");
    this.setHeight();
  },
  methods: {
    policy(data) {
      if(data==1){
        this.isSHowPrivacy = true;
        this.https = 'https://ezt.exporegist.com/AutInteren2021/DataFile/ExhSettingFiles/21/Term%20of%20use_ITSH.pdf';
        // this.https = this.$Url + "api.php?m=h5&mid=53&f=content&id=1";
      }else if(data==2){
        // this.isSHowPrivacy = true;
        // this.https = 'https://www.hk.messefrankfurt.com/hongkong/en/privacy-policy.html';
        
      window.open('https://www.hk.messefrankfurt.com/hongkong/en/privacy-policy.html', "_blank");
      }
      
    },
    closePrivacy() {
      this.isSHowPrivacy = false;
      this.https = "";
    },
    setHeight() {
      this.height = window.innerHeight - 145 + "px";
    },
    emailChange(e) {
      this.email = e;
      if (e.length > 0 && this.password.length > 0) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    },
    passwordChange(e) {
      this.password = e;
      if (e.length > 0 && this.username.length > 0) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    },
    // 忘记密码
    toPathContent(data) {
      this.$router.push({
        name: "register",
        query: {
          forget:data,
        },
      });
    },
    toPath(name) {
      this.$router.push({
        name,
      });
    },
    loginBtn() {
      if (this.username.length == 0) {
        if (this.langSet == "zh") {
          this.$message({
            message: "邮箱/手机号不能为空！",
            center: true,
          });
        } else {
          this.$message({
            message: "Email/mobile number cannot be empty！",
            center: true,
          });
        }
      } else if (this.password.length == 0) {
        if (this.langSet == "zh") {
          this.$message({
            message: "密码不能为空!",
            center: true,
          });
        } else {
          this.$message({
            message: "Password cannot be empty!",
            center: true,
          });
        }
      } else if (!this.checked) {
        if (this.langSet == "zh") {
          this.$message({
            message: "请勾选阅读协议并同意!",
            center: true,
          });
        } else {
          this.$message({
            message: "Please check to read the agreement and agree!",
            center: true,
          });
        }
      } else {
        this.$store.dispatch("userLogin", false);
        localStorage.removeItem('Flag');
        localStorage.removeItem('memberid');
        localStorage.removeItem('uuid');
        localStorage.removeItem('improve');
        let data = this.$qs.stringify({
          clientType: 1,
          version: 1,
          password: this.password,
          username: this.username,
        });
        console.log(this.username, this.password);
        getLogin(data)
          .then((res) => {
            console.log(res);
            if (res.data.errno == 0) {
              this.$store.dispatch("userLogin", true);
              localStorage.setItem("Flag", "isLogin");
              localStorage.setItem("memberid", res.data.rst.memberid);
              localStorage.setItem("uuid", res.data.rst.uuid);
              // console.log(localStorage.getItem('memberid'))
              // console.log(localStorage.getItem('uuid'))//
              //判断是否
              this.$router.push({ path: "/pair" });
            }else if(res.data.errno == 4001){
              if (this.langSet == "zh") {
                this.$message({ message: "用户不存在或账号密码错误！!", });
              } else {
                this.$message({ message: "Incorrect login ID or password!"});
              }

            }else {
              this.$message(res.data.errmsg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
};
</script>

<style lang="scss">
.sign-wrap {
  width: 100%;
  background: url(../../assets/signbg.jpg) no-repeat;
  background-size: 100% 100%;
}
.sign-login-wrap {
  width: 600px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 30px 35px 59px;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.sign-login-wrap h2 {
  font-size: 30px;
  line-height: 42px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 35px;
}
.sign-login-wrap .el-input__inner {
  width: 100%;
  height: 60px;
  background: rgba(244, 244, 244, 1);
  border: 1px solid rgba(218, 218, 218, 1);
  margin-bottom: 20px;
  border-radius: 0;
  font-size: 20px;
  padding-left: 40px;
}
.sign-login-wrap .login-btn {
  width: 100%;
  height: 60px;
  background: rgba(244, 244, 244, 1);
  border: 1px solid rgba(218, 218, 218, 1);
  margin-bottom: 20px;
  border-radius: 0;
  font-size: 20px;
  color: #999;
  text-align: center;
  line-height: 60px;
}
.sign-login-wrap .login-btn.act {
  cursor: pointer;
  background: #9B8B1C;
  border-color: #9B8B1C;
  color: #fff;
}
.login-sub {
  margin-bottom: 32px;
}
.login-sub .el-checkbox__input.is-checked + .el-checkbox__label {
  font-size: 18px;
  color: #666;
}
.login-sub .login-policy {
  font-size: 18px;
  color: #037aff;
  cursor: pointer;
}
.login-sub .el-checkbox__label {
  font-size: 18px;
}
.login-sub .el-checkbox__inner {
  position: relative;
  top: -2px;
}
.login-sub span.login-forget {
  font-size: 20px;
  color: #999;
  float: right;
  cursor: pointer;
}
.login-forget {
  font-size: 20px;
  color: #999;
  // float: right;
  padding: 0px 0px 10px;
  text-align: right;
  cursor: pointer;
}
.login-logo {
  width: 165px;
  margin: 0 auto 20px;
  display: block;
}
.login-botton {
  text-align: center;
  font-size: 20px;
  color: #585858;
}
.login-botton span {
  cursor: pointer;
}
.login-botton .login-register-btn {
  color: #2d90ff;
  margin-left: 30px;
}
.privacyWrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .privacy {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 800px;
    height: 60%;
    overflow: hidden;
    background: #fff;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    .el-icon-close {
      font-size: 30px;
      cursor: pointer;
      margin: 10px;
    }
    .privacyContent {
      padding: 0 15px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .sign-login-wrap {
    width: 95%;
    padding: 0.5rem;
  }
  .login-sub .login-policy,
  .login-sub .el-checkbox__input.is-checked + .el-checkbox__label {
    font-size: 14px;
  }
  .privacyWrap .privacy {
    width: 85%;
    border-radius: 10px;
  }
  .el-icon-close {
    font-size: 20px;
    margin: 0.2rem;
  }
}
</style>